import {
  ApiaUtil,
  ApiaUtilModalHandler,
  SimpleButton,
  TOpenModal,
} from '@apia/components';
import { QueryController } from './QueryController';
import { TResponsiveTableRowsSelectionEvent } from '@apia/table';
import { EventEmitter, getLabel } from '@apia/util';
import { TableControllerEvents } from './table/types';
import { AdditionalFiltersModalController } from './table/AdditionalFilters/AdditionalFiltersModalController';

type QueryModalControllerEvents = Pick<TableControllerEvents, 'onSelectRows'>;

export class QueryModalController {
  private emitter = new EventEmitter<QueryModalControllerEvents>();
  protected queryController: QueryController;
  private modalHandler: ApiaUtilModalHandler | null = null;
  private currentSelection: TResponsiveTableRowsSelectionEvent | null = null;
  private additionalFiltersController: AdditionalFiltersModalController;

  public constructor(queryController: QueryController) {
    if (!queryController) {
      throw new Error('QueryController instance is required');
    }
    this.queryController = queryController;
    this.additionalFiltersController = new AdditionalFiltersModalController(
      this.queryController.tableController,
    );

    this.queryController.tableController.state.props = {
      isMultiple: false,
    };

    this.queryController.tableController.on('onSelectRows', (ev) => {
      this.emitter.emit('onSelectRows', ev);
      this.modalHandler?.close();
    });
    this.queryController.tableController.on('onChangeSelection', (ev) => {
      this.currentSelection = ev;
    });
  }

  protected getModalDefinition(): TOpenModal {
    const tableController = this.queryController.tableController;
    const structure = this.queryController.structure;

    return {
      children: (
        <tableController.Context>
          <tableController.Table />
          <tableController.Pagination />
        </tableController.Context>
      ),
      title: structure?.title,
      onConfirm: () => {
        this.emitter.emit('onSelectRows', this.currentSelection || []);
      },
      onCancel: () => {
        this.additionalFiltersController.closeModal();
      },
      confirmProps: {
        confirmButtonText: getLabel('btnCon').text,
        cancelButtonText: getLabel('btnCan').text,
      },
      NavBar: (
        <SimpleButton
          size="sm"
          variant="outline"
          onClick={() => this.additionalFiltersController.openModal()}
        >
          Additional filters
        </SimpleButton>
      ),
      size: 'finder',
    };
  }

  public getQueryController() {
    return this.queryController;
  }

  public on<K extends keyof QueryModalControllerEvents>(
    ev: K,
    cb: (e: QueryModalControllerEvents[K]) => unknown,
  ) {
    return this.emitter.on(ev, cb);
  }

  public openModal = async (properties?: TOpenModal) => {
    await this.queryController.initialLoad();
    this.modalHandler = ApiaUtil.instance.modals.open({
      ...this.getModalDefinition(),
      ...properties,
    });
  };

  public getModalHandler() {
    return this.modalHandler;
  }
}
